<template lang="pug">
	.web-services--output-param--list-options-editor.flex-col.space.space-large
		.font-big.upper.grey {{$tCaption('Phrases builder')}}		
		.flex-col.space(v-if="listOptions.phrases.length")
			.phrase.flex-1.flex-col.space(v-for="(phrase, phraseIdx) in listOptions.phrases", :key="phrase.id")
				.flex-row.space
					.flex-col.space.flex-4
						.flex-row.align-center.space
							DxButton(icon="close", stylingMode="text", :hint="$tCaption('Remove phrase')", @click="removePhrase(phrase, phraseIdx)")
							.font-big.upper {{$tCaption('Phrase')}} # {{phraseIdx + 1}}
							DxButton.small(:disabled="phraseIdx === 0", icon="fas fa-chevron-up", stylingMode="text", :hint="$tCaption('Move up')", @click="movePositionInArray(listOptions.phrases, phraseIdx, -1)")
							DxButton.small(:disabled="phraseIdx === listOptions.phrases.length-1",icon="fas fa-chevron-down", stylingMode="text", :hint="$tCaption('Move down')", @click="movePositionInArray(listOptions.phrases, phraseIdx, 1)")
							DxButton.small(icon="fas fa-clone", stylingMode="text", :hint="$tCaption('Clone')", @click="duplicatePhrase(phrase, phraseIdx)")
						.flex-col
							.font-small.upper.grey {{$tCaption('Phrase template')}}
							.flex-row.space.align-center
								DxTextArea.flex-1(:value.sync="phrase.phraseTemplate", stylingMode="filled", :placeholder="$tCaption('Example: [ITEMS]')")
						.flex-col
							.font-small.upper.grey {{$tCaption('Item template')}}
							.flex-row.space.align-center
								DxTextArea.flex-1(:value.sync="phrase.itemTemplate", stylingMode="filled")
								DxDropDownButton(icon="fas fa-ellipsis-vertical", :items="getAvailableFields(phrase)", stylingMode="text",  display-expr="id", key-expr="id", :use-select-mode="false", :showArrowIcon="false", 
									:drop-down-options="{ width: 230 }", @item-click="e => phrase.itemTemplate += `@${e.itemData.id}`")
						.flex-row.space.align-center
							.font-small.upper.grey {{$tCaption('Item delimeter')}}
							.flex-row.space.align-center
								DxTextBox.flex-1(:value.sync="phrase.itemDelimeter", stylingMode="filled", :width="40")
					.flex-col.space.flex-1.array-operations-block
						.flex-row.align-center.space
							.font-small.upper.grey {{$tCaption('Array operations:')}}
							DxDropDownButton(icon="plus", :items="operationsList", stylingMode="text",  display-expr="name", key-expr="id", :use-select-mode="false", :showArrowIcon="false", 
								:drop-down-options="{ width: 230 }", @item-click="e => onAddOperationClick(e, phrase)")
						.flex-col.space
							.operation.flex-row.align-center.space-medium.flex-1.justify(v-for="(operation, opIdx) in phrase.operations", :key="operation.id")
								.flex-row.space.align-center
									DxButton(icon="close", stylingMode="text", :hint="$tCaption('Remove OPERATION_NAME').replace(/OPERATION_NAME/gi, allOperations[operation.operation].text)", @click="phrase.operations.splice(opIdx, 1)")
									.font-small.nowrap(:title="allOperations[operation.operation].hint") {{allOperations[operation.operation].text}}						
								.flex-row.space.align-center.flex-1.justify-end
									.flex-col.space.flex-1.justify-end
										.prop.flex-1.flex-row.justify-end(v-for="prop in allOperations[operation.operation].props")
											DxNumberBox(v-if="prop.type === 'number'" stylingMode="filled", :width="40", :value="operation[prop.name]", @value-changed="e => $set(operation, prop.name, e.value)",
												:hint="prop.text", :placeholder="prop.text")
											DxTagBox.flex-1(v-if="prop.type === 'fieldChooser'", :items="getAvailableFields(phrase, opIdx).map(f => f.id)", :value="operation[prop.name]", @value-changed="e => $set(operation, prop.name, e.value)",
												:hint="prop.text", :placeholder="prop.text", :multiline="false", :maxDisplayedTags="1")
											DxSelectBox.flex-1(v-if="prop.type === 'array'", :items="prop.array", valueExpr="key", displayExpr="text", :hint="prop.text", :placeholder="prop.text", 
												:value="operation[prop.name]", @value-changed="e => $set(operation, prop.name, e.value)")
											DxTextBox.flex-1(v-if="prop.type === 'string'", :value="operation[prop.name]", @value-changed="e => $set(operation, prop.name, e.value)", :placeholder="prop.placeholder || prop.text")
											DxButton(v-if="prop.type === 'criteria'", :text="$tCaption('Edit filter criteria')", @click="showCriteria(phrase, opIdx)")
									DxButton.small(:disabled="opIdx === 0", icon="fas fa-chevron-up", stylingMode="text", :hint="$tCaption('Move up')", @click="movePositionInArray(phrase.operations, opIdx, -1)")
									DxButton.small(:disabled="opIdx === phrase.operations.length-1",icon="fas fa-chevron-down", stylingMode="text", :hint="$tCaption('Move down')", @click="movePositionInArray(phrase.operations, opIdx, 1)")
				.flex-col.space
					.upper.grey.flex-row.align-center.space(v-if="phraseResults[phrase.id]")
						span {{$tCaption('Sample result')}}
						fas.clickable.hoverable(icon="circle-question", @click="showTestDataPopup")
					.font-small {{getPhraseResult(phrase) || $Data.limitText(phraseResults[phrase.id], 200)}}
		.flex-row.space
			DxButton(:text="$tCaption('Add phrase')", @click="addPhrase", icon="plus")
		Popup(v-if="criteriaEditorVisible", :popupVisible.sync="criteriaEditorVisible", :width="640", :height="480")
			.flex-col
				template(v-if="editingOperation")
					FilterBuilder(:fields="getFilterBuilderFields(editingPhrase, editingOperationIdx)", v-model="editingCriteria")
			template(slot="actions-right")
				DxButton(:text="$tCaption('Cancel', '@actions')", @click="criteriaEditorVisible = false")
				DxButton(:text="$tCaption('Save', '@actions')", type="default", @click="saveCriteria")
		Popup(v-if="testDataPopupVisible", :popupVisible.sync="testDataPopupVisible", :width="720", :height="640")
			.flex-col.space.web-services--output-param--list-options-editor
				.font-big.upper.grey {{$tCaption('Test data')}}
				.font-small {{$tCaption('Test data is automatically generated. You can make changes (only for temporary testing purposes, that data won\'t be saved anywhere except current session).')}}
				DxTextArea.test-data-area(:value.sync="testDataString", :height="450", stylingMode="filled")
			template(slot="actions-right")
				DxButton(:text="$tCaption('Close', '@actions')", @click="testDataPopupVisible = false")
</template>

<script>
import _ from 'lodash';
import DxButton from 'devextreme-vue/button';
import DxTextArea from 'devextreme-vue/text-area';
import DxNumberBox from 'devextreme-vue/number-box';
import DxDropDownButton from 'devextreme-vue/drop-down-button';
import DxTagBox from 'devextreme-vue/tag-box';
import DxSelectBox from 'devextreme-vue/select-box';
import DxTextBox from 'devextreme-vue/text-box';
import FilterBuilder from 'app-core/FilterBuilder.vue';
import Popup from 'app-core/Popup.vue';
import listHelper from './param-list-options-helper';
import json5 from 'json5';

export default {
	translationCategory: 'webServiceCaller.OutputParamListOptionsEditor',
	components: { DxButton, DxTextArea, DxNumberBox, DxDropDownButton, DxTagBox, DxSelectBox, DxTextBox, FilterBuilder, Popup },
	props: ['output', 'service', 'options'],
	data() {
		return {
			listOptions: {
				phrases: [],
				...(_.cloneDeep(this.options) || {})
			},
			allOperations: listHelper.getAllOperations(),
			criteriaEditorVisible: false,
			editingPhrase: null,
			editingOperationIdx: null,
			editingCriteria: null,
			testData: listHelper.getTestData(this.output.ArrayFields, 10),
			testDataPopupVisible: false,
			phraseResults: {}
		};
	},
	computed: {
		operationsList() {
			return Object.keys(this.allOperations).map(f => ({
				id: f,
				name: this.allOperations[f].text
			}));
		},
		editingOperation() {
			return this.editingPhrase?.operations[this.editingOperationIdx];
		},
		testDataString: {
			get: function() {
				return JSON.stringify(this.testData, void 0, 4)
					.replace(/[,]\n/g, ', ')
					.replace(/, {8}/g, ', ');
			},
			set: function(v) {
				try {
					const newData = json5.parse(v);
					this.testData = newData;
				} catch(ex) {
					this.$notifyError(ex);
				}
			}
		}
	},
	watch: {
		listOptions: {
			handler(v) {
				this.$emit('change', v);
			},
			deep: true
		}
	},
	mounted() {
		if (__DEBUG__) {
			window.phrasesBuilder = this;
			window.listOptionHelper1 = listHelper;
		}
	},
	methods: {
		removePhrase(phrase, phraseIdx) {
			this.$confirm(this.$tCaption('Confirm action', '@actions'), this.$tCaption('Do you want to remove phrase?'))
				.then(() => this.listOptions.phrases.splice(phraseIdx, 1));
		},
		duplicatePhrase(phrase, phraseIdx) {
			const newPhrase = {
				..._.cloneDeep(phrase),
				id: this.$Data.uuid()
			}
			this.listOptions.phrases.splice(phraseIdx + 1, 0, newPhrase);
			this.$notifySuccess(this.$tCaption('Phrase duplicated'));
		},
		showTestDataPopup() {
			this.testDataPopupVisible = false;
			setImmediate(() => this.testDataPopupVisible = true);
		},
		saveCriteria() {
			this.editingOperation.filter = this.editingCriteria;
			this.criteriaEditorVisible = false;
		},
		showCriteria(phrase, operationIdx) {
			this.editingPhrase = phrase;
			this.editingOperationIdx = operationIdx;
			this.criteriaEditorVisible = false;
			this.editingCriteria = this.editingOperation.filter;
			setImmediate(() => this.criteriaEditorVisible = true);
		},
		getAvailableFields(phrase, operationIdx) {
			const existingGroupOperation = phrase.operations.filter((f, idx) => f.operation === 'group' && (operationIdx === void 0 || idx < operationIdx)).reverse()[0];
			if (existingGroupOperation) {
				const items = [...(existingGroupOperation.dimensions || []), ...(existingGroupOperation.aggregations || [])];
				return this.output.ArrayFields.filter(f => items.includes(f.id));
			}
			return this.output.ArrayFields;
		},
		getFilterBuilderFields(phrase, operationIdx) {
			return this.getAvailableFields(phrase, operationIdx).map(f => ({
				caption: f.id,
				dataField: f.id,
				dataType: f.dataType,
			}));
		},
		movePositionInArray(array, currentPosition, direction) {
			var item = array[currentPosition];
			array.splice(currentPosition, 1);
			array.splice(currentPosition + direction, 0, item);
		},
		onAddOperationClick(e, phrase) {
			const operation = this.allOperations[e.itemData.id];
			const res = {
				id: this.$Data.uuid(),
				operation: e.itemData.id,
				...(operation.default || {})
			}
			phrase.operations.push(res)
		},
		addPhrase() {
			this.listOptions.phrases.push({
				id: this.$Data.uuid(),
				operations: [],
				itemTemplate: '',
				itemDelimeter: ',',
				phraseTemplate: '[ITEMS]'
			});
		},
		getPhraseResult(phrase) {
			try {
				listHelper.dataOperations.processPhrase(this.testData, phrase).then(r => this.$set(this.phraseResults, phrase.id, r));
			} catch(ex) {
				if (__DEBUG__)
					console.error(ex);
			}
		}
	}
};
</script>
<style lang="scss">
	.web-services--output-param--list-options-editor {
		.operation {
			padding: 3px;
			box-shadow: 0px 1px 4px #dedede;
			margin: 2px;
			background: #f1f1f1;
			min-width: 400px;
		}

		.array-operations-block {
			border-left: 2px solid #f5f5f5;
			padding-left: 8px;
			margin-left: 4px;
			min-width: 415px;
		}

		.phrase	{ 
			background: #f9f9f9;
			padding: 14px;
			box-shadow: 0px 2px 7px #c1c1c1;
			border-radius: 3px;
		}

		.test-data-area {
			textarea {
				font-size: 10px;
				line-height: 1;
			}
		}
	}
</style>
